import { render, staticRenderFns } from "./RegionNum.vue?vue&type=template&id=bd38dee0&scoped=true"
import script from "./RegionNum.vue?vue&type=script&lang=js"
export * from "./RegionNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd38dee0",
  null
  
)

export default component.exports